import { Component, ViewChild, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, SimpleChanges, TemplateRef } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDialog } from '@angular/material/dialog';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { Observable } from 'rxjs';
import { ConfirmDialogModel, ConfirmDialogComponent } from '../reusableComponents/confirm-dialog/confirm-dialog.component';
import { environment } from 'src/environments/environment';
import { StatusConstant } from '../status/status-constant';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { ModuleName, RoleLevel } from '../Enum/common.enum';
import { AttachToTaskListComponent } from '../attachToTaskList/attachToTaskList.component';
import { ImportForm3CListComponent } from '../importForm3C/importForm3C.component';
import { AddOfficeComponent } from '../addOffice/addOffice.component';
import { DownloadService } from 'src/app/applicationModules/settings/services/settingService/download-service.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Content } from '@angular/compiler/src/render3/r3_ast';
const FileSaver = require('file-saver');
import * as FileSaver from 'file-saver';
import * as JSZip from 'jszip';
import { LoaderService } from '../../shared/loader/loader.service';
import { saveAs } from 'file-saver';
import { FolderForReferralComponent } from '../folderForReferral/FolderForReferral.component';

@Component({
  selector: 'app-Listingtable',
  templateUrl: './Listingtable.component.html',
  styleUrls: ['./Listingtable.component.scss'],
  providers: [DatePipe],
})

export class ListingTableComponent implements OnInit {

    colors = [
  { color: "#e6194b" }, // Red
  { color: "#3cb44b" }, // Green
  { color: "#ffe119" }, // Yellow
  { color: "#4363d8" }, // Blue
  { color: "#f58231" }, // Orange
  { color: "#911eb4" }, // Purple
  { color: "#46f0f0" }, // Cyan
  { color: "#f032e6" }, // Magenta
  { color: "#bcf60c" }, // Lime
  { color: "#fabebe" }, // Light Pink
  { color: "#008080" }, // Teal
  { color: "#e6beff" }, // Lavender
  { color: "#9a6324" }, // Brown // Cream
  { color: "#800000" }, // Maroon
  { color: "#aaffc3" }, // Mint
  { color: "#808000" }, // Olive // Peach
  { color: "#000075" }, // Navy Blue
  { color: "#808080" }  // Gray
];

  @Input() targetList: any = [];
  @Input() coreFieldList: any = [];
  @Input() dataSources: any = [];
  @Input() filterList: any = [];
  @Input() FieldColumnToogle: any = [];
  @Input() allids: any = [];
  @Input() Filtername: string='';
  @Input() isAnyRecordAvailable: boolean=false;
  @Input() statusColorList: any = []=[];
  
  @Input() showPaycheck:boolean=false;
  @Input() showPCC: boolean=false;
  @Input() modulename: string='';                      // being used to get list from parent component $$....  
  @Input() totalCount: number=0;                        // Count of full list, being used in pagination total length $$....
  @Input() pageIndex?: number = 0;                    // Page index can be set from parent component in eg. 1 $$....
  @Input() pageSize: number=0;                          // Default page size can be set from parent component in eg. 10 $$....
  @Input() displayedColumns: string[];                // being used to set definition of mat-table columns


  @Output() pageChangeEvent = new EventEmitter();     // will call table data based on selection in paginator $$....
  @Output() dropListDropped = new EventEmitter();
  @Output() serachRecord = new EventEmitter();
  @Output() filterNameClick = new EventEmitter();
  @Output() showView = new EventEmitter();  
  @Output() selectedRecordForAddFavorite = new EventEmitter();
  @Output() selectedRecordForAddImportant = new EventEmitter();
  @Output() selectedRecordForDeleteFavorite = new EventEmitter();
  @Output() selectedRecordForDeleteImportant = new EventEmitter();
  @Output() selectedRecordDelete = new EventEmitter();
  @Output() selectedRecordArchive = new EventEmitter();
  @Output() selectedRecordActivate = new EventEmitter();
  @Output() selectedRecordSendtoPaychex = new EventEmitter();
  @Output() SendtoAttachToTaskList= new EventEmitter();
  @Output() selectedRecordSendtoPendingPatientPCC = new EventEmitter();
  @Output() selectedCustColumn = new EventEmitter();
  @Output() addFilterEvent = new EventEmitter();
  @Output() ArchivedFilterEvent = new EventEmitter();
  @Output() showRightSidePanel = new EventEmitter();
  @Output() addNewRecord = new EventEmitter();

  @Output() CheckBoxClearExport = new EventEmitter();

  @Output() addFavoriteForFilter = new EventEmitter();
  @Output() deleteFavoriteForFilter = new EventEmitter();
  @Output() removeSelectedFilter = new EventEmitter();
  @Output() startBroadCasting = new EventEmitter();

  @Output() selectedTransactionId = new EventEmitter();
   @Output() sorList= new EventEmitter();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  selection = new SelectionModel(true, []);
  dataSource: MatTableDataSource<any>;
  filteredList: any = [];
  pageSizeOptions: number[] = [20, 50, 100];
  paginatorTotalLength = 0;
  filterText: any;
  value = '';
  showDetail: boolean = false;
  DataSource = [];
  SelectedRecordForDeleFav: boolean = false;
  selectedRecordCount: number=0;
  FilterNameList: any = [];
  databaseId: string;
  organizationId: string;
  currentUser: any;
  SubmitColumnsButton: boolean = false;
  currentFavoriteElement : any;
  currentImportantFavoriteElement: any;
  SelectedIdList: any = [];
  responseHolder: any;
  ToogleColumnFields: any = [];
  deleteList: any = [];
  selectedRecordDeleteArray: any = [];
  allrecordcount: number=0;

  folderListForID: any = [];
  folderId: number = 0;
  showLocalPanel: boolean = false;

  initialCount: number=0;
  filterApplied: boolean=false;
  CCCList: any=[];
  isChecked = false;
  selectedForFalse: any = [];
  selectedForTrue: any = [];
  OfficeIDList: any = [];
  myOfficeID: any;
  checkedAll: boolean = false;
  BroadCastHide: boolean = false;
  colCount = 0;
  mainModuleName:string="";
  ShowPaycheck:boolean=false;
  ShowPointClickCare:boolean=false;
  rolesAsssign: any[] = [];
  showAction:boolean=false;

  constructor(private cdr: ChangeDetectorRef, private _dataSharingService: DataSharingService, private router: Router,
    public datepipe: DatePipe, private dialog: MatDialog, private reusableClass: ReusableClasses, private encryptionAlgo: EncryptionService,
    private statusConstant: StatusConstant, private settingsService: SettingService, private toastr: ToastrService,
    private downloadService: DownloadService,private formBuilder: FormBuilder,
    private httpClient: HttpClient,private loaderService: LoaderService,
    private http: HttpClient) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = [];
    offices = JSON.parse(sessionStorage.getItem('officeList')|| '[]');
    if (offices.length > 0) {
      offices.forEach((oe:any) => {
        this.OfficeIDList.push(oe.officeID)
        if (oe.isMyoffice == true)
          this.myOfficeID = oe.officeID;
      });
    }
  }

  isPhone(element: any, fieldName: string): boolean {
    return this.getKeyByValue(element, element[fieldName]) == 'Phone';
  }

  isEmail(element: any, fieldName: string): boolean {    
    return this.getKeyByValueEmail(element, element[fieldName]) == 'Email';
  }

  getKeyByValueEmail(object:any, value:any) {
    if(value!="—"){
      return Object.keys(object).find(key => object[key] === value);
    }    
  }

  getKeyByValue(object:any, value:any) {   
    return Object.keys(object).find(key => object[key] === value);   
  }

 

  ngOnChanges(changes: SimpleChanges) {
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules")|| '[]');
    this.CCCList = menuModulesList.filter((x:any) => x.mainModuleName == ModuleName.Core || x.mainModuleName == ModuleName.Contact || x.mainModuleName == ModuleName.Company);
    if (this.targetList != undefined) {

     if (this.displayedColumns && this.displayedColumns.length > 0) {
      this.displayedColumns = this.displayedColumns.filter((col, index, self) => self.indexOf(col) === index);
     }
      
      this.isAnyRecordAvailable;
      this.SubmitColumnsButton = false;
      this.filteredList = [];
      this.filteredList = this.targetList;    
      this.colCount = 0;

      this.isAnyRecordAvailable && this.filteredList.forEach((element:any) => {
        this.colCount = element.isDisplay == true ? this.colCount + 1 : 0;
      });

      // this.filteredList = this.filteredList.filter((v, i) => this.filteredList.findIndex(item => item.fieldID == v.fieldID) === i);

      this.Filtername;
      this.DataSource = this.dataSources;//.map(s => Object.assign(s));
      this.allrecordcount = this.totalCount;//this.DataSource.length;
      this.displayedColumns = [...new Set(this.displayedColumns)];
      this.displayedColumns = this.displayedColumns;
      this.paginatorTotalLength = this.totalCount;
      if(this.allrecordcount>0){
        this.getThirdPartyApplicationList();
      }

      //this.FilterNameList= this.filterList.filter((v, i) => this.filterList.findIndex(item => item.filterID == v.filterID) === i);

      this.FilterNameList = this.filterList.filter((v:any, i:any) => this.filterList.findIndex((item:any) => item.filterName == v.filterName) === i);

      this.FieldColumnToogle;
      this.setListForToggle();

      this.modulename;
      this.createTargetTable();
      this.selectedRecordDeleteArray;
      this.allids;

      if (this.initialCount == undefined) {
        this.initialCount = this.totalCount;
      }
      // if(this.Filtername=="All Core" && this.initialCount==this.allrecordcount || this.Filtername=="All Contact" && this.initialCount==this.allrecordcount || this.Filtername=="All Company" && this.initialCount==this.allrecordcount){
      //   this.filterApplied=false;
      // }else{
      //   this.filterApplied=true;
      // }

      var GetFolderId = [];
      GetFolderId = this.CCCList.filter((x:any) => x.orgModuleName == this.modulename);
      if (GetFolderId.length > 0) {
        this.FolderId = GetFolderId[0].folderID;
        if (GetFolderId[0].mainModuleName == ModuleName.Core) {
          this.TypeIdForExport = 1;
          this.BroadCastHide = true;
          this.mainModuleName =GetFolderId[0].mainModuleName;
        }
        if (GetFolderId[0].mainModuleName == ModuleName.Contact) {
          this.TypeIdForExport = 2;
          this.BroadCastHide = false;
          this.mainModuleName =GetFolderId[0].mainModuleName;
        }
        if (GetFolderId[0].mainModuleName == ModuleName.Company) {
          this.TypeIdForExport = 3;
          this.BroadCastHide = false;
          this.mainModuleName =GetFolderId[0].mainModuleName;
        }
      }

      // if(this.selectedRecordDeleteArray.length > 0){
      //     this.selection.clear();
      //    for (var i = 0, len = this.selectedRecordDeleteArray.length; i < len; ++i){
      //      var id = this.dataSource.data.findIndex(el => el.CoreID === this.selectedRecordDeleteArray[i].selectedRecord)
      //     if(id > 0 || id ==0){
      //       this.selection.select(this.dataSource.data[id]);
      //     }        
      //   }
      // }   

      if (environment.production) {
        this.showLocalPanel = false;
      } else {
        this.showLocalPanel = true;
      }

      var paychecks = sessionStorage.getItem('Paycheck');
      var PointClickCare = sessionStorage.getItem('PointClickCare');
      if(paychecks=="true"){
        this.ShowPaycheck=true;
      }
      if(PointClickCare=="true"){
        this.ShowPointClickCare=true;
      }

      this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles")|| '[]');   
      if(this.rolesAsssign.length > 0){
        var role=[];
         // roleLevel:1 (Super admin), roleLevel:2 (Organization Admin), roleLevel:3 (Office Admin),
         // roleLevel:11 (User)
                
      //   role = this.rolesAsssign.filter((m) => m.roleLevel ==  RoleLevel.OrganizationAdmin ||
      //     m.roleLevel == RoleLevel.OfficeAdmin);
      //   if(role.length > 0){
      //    this.showAction=true;
      //  }else{
      //   this.showAction=false;
      //  }
      }
      this.cdr.detectChanges();
    }
  }

  ngOnInit() {
    this.SelectedRecordForDeleFav = false;
  }

  getStatusColor(element:any) {      
    let color="";
    if(this.statusColorList && this.statusColorList.length>0){
      this.statusColorList.forEach((x:any) => 
       {
          if(x.status == element){
            color = x.color
          }
        });
    }    
    return color;
  }


 
  createTargetTable() {
    this.dataSource = new MatTableDataSource<any>();
    this.dataSource.data = this.DataSource;
    this.sort = null;
    this.dataSource.sort = this.sort;
   // var record:number=0;
   // this.selectedRecordDeleteArray;
    //record=this.selectedRecordDeleteArray.length;

    if (this.dataSource.data.length > 0) {
      const myArrayFiltered = this.dataSource.data.filter((el) => {
        return this.selectedRecordDeleteArray.some((f:any) => {
          return f.selectedRecord === el.CoreID;
        });
      });
      
     if (myArrayFiltered.length == this.dataSource.data.length) {
        this.checkedAll = true;
      } else {
        this.checkedAll = false;
      }
      
      // if (myArrayFiltered.length == this.dataSource.data.length) {
      //   this.checkedAll = true;
      // } else {
      //   this.checkedAll = false;
      // }
    }

    if (this.selectedRecordDeleteArray.length > 0) {
      for (var i = 0, len = this.selectedRecordDeleteArray.length; i < len; ++i) {
        var Check = [];
        Check = this.dataSource.data.filter((x:any) => x.CoreID == this.selectedRecordDeleteArray[i].selectedRecord);
        if (Check.length > 0) {
          this.dataSource.data.find(y => y.CoreID == this.selectedRecordDeleteArray[i].selectedRecord).IsChecked = true;
        }
      }
    } else {
      this.dataSource.data.forEach(e => {
        e.IsChecked = false
      });
    }
  }

  ngAfterViewInit() {
    this.createTargetTable();
  }

  customizeColumn(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }

  applyFilter() {
    this.addFilterEvent.emit();
  }

  ArchivedFilter() {
    //this.value = "";
    this.SelectedRecordForDeleFav = false;
    this.selectedRecordDeleteArray = [];
    this.Filtername = "Archived";
    this.ArchivedFilterEvent.emit();
  }

  OnFilterNameClick(filter:any) {
    this.Filtername = filter.filterName;
    if (filter.filterID == 0) {
      var selectedfilterList = filter;
      this.filterNameClick.emit(selectedfilterList);
      this.SelectedRecordForDeleFav = false;
      this.selectedRecordDeleteArray = [];
      this.checkedAll = false;
      //this.selection.clear();       
    } else {
      var selectedfilterList = filter;
      this.filterNameClick.emit(selectedfilterList);
      this.filterApplied = true;
      this.SelectedRecordForDeleFav = false;
      this.selectedRecordDeleteArray = [];
      this.checkedAll = false;
      //this.selection.clear();        
    }

  }

  addNew() {
    this.addNewRecord.emit();
  }


  pageSizeforStore:any;
  // will call data according to selection in paginator $$...
  pageEventPropogate(eventData: PageEvent) {
    this.checkedAll = false;
    this.filterText = '';
    eventData.pageIndex;
    this.pageIndex;
    this.pageSizeforStore=eventData.pageSize;
    if(this.mainModuleName=="Core"){
      this.AddPreferences();
    }
    this.pageChangeEvent.emit(eventData);
  }

  AddPreferences() {
    var ReqModel = {
      userPreferenceID:0,
      key:"Paging",
      value:this.pageSizeforStore.toString(),
      userId: this.currentUser.UID,
      createdBy: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
    }
    this.settingsService.AddPreferences(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {          
         
        } else {
         
        }
      } else {
       
      }
    });
  }



  dropListDroppedEvent(event: CdkDragDrop<string[]>) {
    this.colCount = 0;
    this.dropListDropped.emit(event);
    this.filteredList.forEach((element:any) => {
      this.colCount = element.isDisplay == true ? this.colCount + 1 : 0;
    });
  }


  clearFilter() {
    this.value = "";
    this.filterText = "";
    this.modulename;
    this.serachRecord.emit(this.value);
  }


  Search(filterValue:any) {
    this.modulename;
    this.serachRecord.emit(filterValue);
  }


  showListingDetail(actionObjnew?: any, actionObj?: any) {
    if (actionObj != 'Name') {
   
      this.showDetail = true;
      const id = actionObjnew.CoreID;
      var list=[];
      var fildsList=[];

      var SelectedValue = this.CCCList.filter((x:any) => x.orgModuleName == this.modulename);
      if (SelectedValue[0].mainModuleName == ModuleName.Core){
        list =  JSON.parse(sessionStorage.getItem("coreList")|| '[]');    
      }
      
       if (SelectedValue[0].mainModuleName == ModuleName.Contact){
        list =  JSON.parse(sessionStorage.getItem("contactList")|| '[]');       
       }
       if (SelectedValue[0].mainModuleName == ModuleName.Company){
        list =  JSON.parse(sessionStorage.getItem("companyList")|| '[]');      
       }
       if(list==null){
          list=[];
        }
       if(list.length>0){
        if (SelectedValue[0].mainModuleName == ModuleName.Core){
          list = list.filter((x:any)=>x.coreID == id);
        }
        if (SelectedValue[0].mainModuleName == ModuleName.Contact){
          list = list.filter((x:any)=>x.contactID == id);
        }
        if (SelectedValue[0].mainModuleName == ModuleName.Company){
          list = list.filter((x:any)=>x.companyID == id);
        }
        if(list.length>0){
          fildsList =list[0].fields;
          if(fildsList.length>0){
            fildsList=fildsList.filter((x:any)=>x.fieldName=="Type");
            if(fildsList.length>0){
              actionObjnew.TypeID=fildsList[0].subFolderID;
            }
          }
        }     
       }
      if (actionObjnew.TypeID == null || actionObjnew.TypeID == undefined) {
        actionObjnew.TypeID = 0;
      }      
      var obj = {
        transactionID: id,
        TypeID: actionObjnew.TypeID
      }
      this.selectedTransactionId.emit(obj);
      //this._dataSharingService.sendCore1User(id);
      this.showRightSidePanel.emit();
    }
  }

  CCCListing() {
    var SelectedValue = this.CCCList.filter((x:any) => x.orgModuleName == this.modulename);
    if (SelectedValue[0].mainModuleName == ModuleName.Core) {
      sessionStorage.setItem('coreshowListing', 'true'); 
      sessionStorage.removeItem("coreshowkanban");
      sessionStorage.removeItem("coreshowGrouping");     
      this.router.navigate(['/core/listing'], {});
    }

    if (SelectedValue[0].mainModuleName == ModuleName.Contact) {
      sessionStorage.setItem('contactshowListing', 'true');  
      sessionStorage.removeItem("contactshowkanban");   
      sessionStorage.removeItem("contactshowGrouping");   
      this.router.navigate(['/contact/listing'], {});
    }

    if (SelectedValue[0].mainModuleName == ModuleName.Company) {
      sessionStorage.setItem('companyshowListing', 'true');
      sessionStorage.removeItem("companyshowkanban");    
      sessionStorage.removeItem("companyshowGrouping");   
      this.router.navigate(['/company/listing'], {});
    }
  }


  CCCKanban() {
    var SelectedValue = this.CCCList.filter((x:any) => x.orgModuleName == this.modulename);
    if (SelectedValue[0].mainModuleName == ModuleName.Core) {
      sessionStorage.setItem('coreshowkanban', 'true');
      sessionStorage.removeItem("coreshowListing");     
      sessionStorage.removeItem('coreshowGrouping');
      this.router.navigate(['/core/kanbanview'], {});
    }

    if (SelectedValue[0].mainModuleName == ModuleName.Contact) {
      sessionStorage.setItem('contactshowkanban', 'true');
      sessionStorage.removeItem("contactshowListing");     
      sessionStorage.removeItem('contactshowGrouping');
      this.router.navigate(['/contact/kanbanview'], {});
    }

    if (SelectedValue[0].mainModuleName == ModuleName.Company) {
      sessionStorage.setItem('companyshowkanban', 'true');
      sessionStorage.removeItem("companyshowListing");     
      sessionStorage.removeItem('companyshowGrouping');
      this.router.navigate(['/company/kanbanview'], {});
    }
  }

  CCCGridView(){
    sessionStorage.setItem("gridViewModuleName",this.mainModuleName);
    if(this.mainModuleName == ModuleName.Core){
      sessionStorage.setItem("coreshowGrouping", 'true');    
      sessionStorage.removeItem('coreshowListing'); 
      sessionStorage.removeItem("coreshowkanban");     
    }
    if(this.mainModuleName == ModuleName.Contact){
      sessionStorage.setItem("contactshowGrouping", 'true');    
      sessionStorage.removeItem('contactshowListing'); 
      sessionStorage.removeItem("contacteshowkanban");  
    }
    if(this.mainModuleName == ModuleName.Company){
      sessionStorage.setItem("companyshowGrouping", 'true');    
      sessionStorage.removeItem('companyshowListing'); 
      sessionStorage.removeItem("companyshowkanban");  
    }
    this.router.navigate(['gridView']);    
  }

  OpenProfile(actionObj: any) {
    var SelectedValue = this.CCCList.filter((x:any) => x.orgModuleName == this.modulename);
    const id = actionObj.CoreID;
    var list=[];
    var fildsList=[];
  
    if (SelectedValue[0].mainModuleName == ModuleName.Core){
      list =  JSON.parse(sessionStorage.getItem("coreList")|| '[]');
    }
    
     if (SelectedValue[0].mainModuleName == ModuleName.Contact){
      list =  JSON.parse(sessionStorage.getItem("contactList")|| '[]');
     }
     if (SelectedValue[0].mainModuleName == ModuleName.Company){
      list =  JSON.parse(sessionStorage.getItem("companyList")|| '[]');
     }
     if(list==null){
      list=[];
     }
     if(list.length>0){
      if (SelectedValue[0].mainModuleName == ModuleName.Core){
        list = list.filter((x:any)=>x.coreID == id);
      }
      if (SelectedValue[0].mainModuleName == ModuleName.Contact){
        list = list.filter((x:any)=>x.contactID == id);
      }
      if (SelectedValue[0].mainModuleName == ModuleName.Company){
        list = list.filter((x:any)=>x.companyID == id);
      }
      if(list.length>0){
        fildsList =list[0].fields;
        if(fildsList.length>0){
          fildsList=fildsList.filter((x:any)=>x.fieldName=="Type");
          if(fildsList.length>0){
            actionObj.TypeID=fildsList[0].subFolderID;
          }
        }
      }     
     }
    if (actionObj.TypeID == null || actionObj.TypeID == undefined) {
      actionObj.TypeID = 0;
    }     
    sessionStorage.setItem('transactionID', id);
    sessionStorage.setItem('TypeID', actionObj.TypeID);
    sessionStorage.setItem('moduleName', SelectedValue[0].mainModuleName);
    if (SelectedValue[0].mainModuleName == ModuleName.Core) {
      let tasktab = "/core/documents?&tID=" + btoa(id) + "&type=" + btoa(actionObj.TypeID);
      // let tasktab = "/core/documents?&tID=" + id + "&type=" + actionObj.TypeID;
      window.open(tasktab, "_blank");
      // this.router.navigate(['/core/documents'], {});
      this._dataSharingService.sendNextPreviousDocumentFromCore(false);
      this._dataSharingService.sendNextPreviousForRightPanelFromCore(false);
      this._dataSharingService.sendNextPreviousForTouchesFromCore(false);
      //  this._dataSharingService.sendSelectedCoreUser(tagId);
    }

    if (SelectedValue[0].mainModuleName == ModuleName.Contact) {
      let tasktab = "/contact/documents?&tID=" + btoa(id) + "&type=" + btoa(actionObj.TypeID);
      window.open(tasktab, "_blank");
      // this.router.navigate(['/contact/documents'], {});
      this._dataSharingService.sendNextPreviousDocumentFromContact(false);
      this._dataSharingService.sendNextPreviousForRightPanelFromContact(false);
      this._dataSharingService.sendNextPreviousForTouchesFromContact(false);
      // this._dataSharingService.sendSelectedContactUser(tagId);
    }

    if (SelectedValue[0].mainModuleName == ModuleName.Company) {
      let tasktab = "/company/documents?&tID=" + btoa(id) + "&type=" + btoa(actionObj.TypeID);
      window.open(tasktab, "_blank");
      // this.router.navigate(['/company/documents'], {});
      this._dataSharingService.sendNextPreviousDocumentFromCompany(false);
      this._dataSharingService.sendNextPreviousForRightPanelFromCompany(false);
      this._dataSharingService.sendNextPreviousForTouchesFromCompany(false);
      //this._dataSharingService.sendSelectedCompanyUser(tagId);
    }
  }

  ViewProfile(actionObj: any) {
    var SelectedValue = this.CCCList.filter((x:any) => x.orgModuleName == this.modulename);
    const id = actionObj.CoreID;
    // var tagId = {
    //   Id: id,
    //   moduleName:SelectedValue[0].mainModuleName,
    //   TypeID:actionObj.TypeID
    // };
    var list=[];
    var fildsList=[];
  
     if (SelectedValue[0].mainModuleName == ModuleName.Core){
      list =  JSON.parse(sessionStorage.getItem("coreList")|| '[]');
     }    
     if (SelectedValue[0].mainModuleName == ModuleName.Contact){
      list =  JSON.parse(sessionStorage.getItem("contactList")|| '[]');
     }
     if (SelectedValue[0].mainModuleName == ModuleName.Company){
      list =  JSON.parse(sessionStorage.getItem("companyList")|| '[]');
     }
     if(list==null){
       list=[];
     }
     if(list.length>0){
      if (SelectedValue[0].mainModuleName == ModuleName.Core){
        list = list.filter((x:any)=>x.coreID == id);
      }
      if (SelectedValue[0].mainModuleName == ModuleName.Contact){
        list = list.filter((x:any)=>x.contactID == id);
      }
      if (SelectedValue[0].mainModuleName == ModuleName.Company){
        list = list.filter((x:any)=>x.companyID == id);
      }
      if(list.length>0){
        fildsList =list[0].fields;
        if(fildsList.length>0){
          fildsList=fildsList.filter((x:any)=>x.fieldName=="Type");
          if(fildsList.length>0){
            actionObj.TypeID=fildsList[0].subFolderID;
          }
        }
      }     
     }
    if (actionObj.TypeID == null || actionObj.TypeID == undefined) {
      actionObj.TypeID = 0;
    }    
    
    sessionStorage.setItem('transactionID', id);
    sessionStorage.setItem('TypeID', actionObj.TypeID);
    sessionStorage.setItem('moduleName', SelectedValue[0].mainModuleName);
    if (SelectedValue[0].mainModuleName == ModuleName.Core) {
      this.router.navigate(['/core/documents'], {});
      this._dataSharingService.sendNextPreviousDocumentFromCore(false);
      this._dataSharingService.sendNextPreviousForRightPanelFromCore(false);
      this._dataSharingService.sendNextPreviousForTouchesFromCore(false);
      //  this._dataSharingService.sendSelectedCoreUser(tagId);
    }

    if (SelectedValue[0].mainModuleName == ModuleName.Contact) {
      this.router.navigate(['/contact/documents'], {});
      this._dataSharingService.sendNextPreviousDocumentFromContact(false);
      this._dataSharingService.sendNextPreviousForRightPanelFromContact(false);
      this._dataSharingService.sendNextPreviousForTouchesFromContact(false);
      // this._dataSharingService.sendSelectedContactUser(tagId);
    }

    if (SelectedValue[0].mainModuleName == ModuleName.Company) {
      this.router.navigate(['/company/documents'], {});
      this._dataSharingService.sendNextPreviousDocumentFromCompany(false);
      this._dataSharingService.sendNextPreviousForRightPanelFromCompany(false);
      this._dataSharingService.sendNextPreviousForTouchesFromCompany(false);
      //this._dataSharingService.sendSelectedCompanyUser(tagId);
    }
  }

  showAllRecords() {
    window.location.reload();
  }

  // getShortName(fullName) {
  //   fullName = fullName.Name;
  //   if (fullName != undefined) {
  //     if (fullName.includes(' ')) {
  //       return fullName.split(' ').map((n) => n[0]).join('');
  //     }
  //     return fullName.substring(0, 1);
  //   }
  //   return '';
  // }


  getShortName(fullName:any) {
    fullName = fullName.Name;
    // fullName = fullName.Name;
    fullName = fullName.split(',');
    // var name =fullName [0]+fullName[1];
    if (fullName != undefined) {
      if (fullName.includes(' ')) {
        return fullName.split(' ').map((n:any) => n[0]).join('');
      }
      var First = fullName[0];
      //var second = fullName[1].replace(/\s/g, "").substring(0, 1);
      fullName = First;
      // fullName = First+" "+second;
      return fullName.split(' ').map((n:any) => n[0]).join('');
      // return fullName.substring(0, 1);
    }
    return '';
  }

  getFullName(fullName:any, column:any) {
    var tarea = fullName.Name;
    if (/(http(s?)):\/\//i.test(tarea)) {
      fullName = fullName.Name;
      fullName = fullName.split(',');
      return fullName[0];
    } else {
      fullName = fullName.Name;
      return fullName;
    }
  }

getIsFavorite(element: any): boolean {
  return !!element.IsFavorite;
}

//   getIsImportant(element: any): boolean {
//     let isImportant = element.IsImportant;
//     return isImportant;
// }


  DeleteImportant(element: any) : void {
    element.IsImportant = false;
    this.toastr.info('Marked as unimportant successfully.', '', { timeOut: 3000 });
    this.deleteList = [];
    var id = element.CoreID;
    this.deleteList.push(id);

    this.selectedRecordForDeleteImportant.emit(this.deleteList);

    this.SelectedRecordForDeleFav = false;
    this.selectedRecordDeleteArray = [];
    this.checkedAll = false;
    
  }


  getpaychexID(paychexID:any) {
    paychexID = paychexID.paychexID;
    return paychexID;
  }

  getPendingPatientID(PendingPatient:any) {
    return PendingPatient.pendingPatientId;
  }
  getIsFavoriteForFilter(isFavorite:any) {
    isFavorite = isFavorite.isDefault;
    return isFavorite;
  }


  getImageUrlPath(Imagepath:any) {
    Imagepath = Object.values(Imagepath)[0];
    if (Imagepath != undefined) {
      Imagepath = Imagepath.toString().split(',');
      if (Imagepath.length > 1) {
        return Imagepath[1];
      } else {
        return '';
      }
    }
    return '';
  }

  goToLink(url: string) {
    if (url != '—') {
      if (url.substring(0, 4) == 'http') {
        window.open(url, '_blank');
      } else {
        window.open('https:' + url, '_blank');
      }
    }
  }

  close() {
    this.dialog.closeAll();
  }

  setListForToggle() {
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules")|| '[]');
    var modulename = menuModulesList.filter((x:any) => x.orgModuleName == this.modulename);
    if (modulename[0].mainModuleName == ModuleName.Core) {
      this.isAnyRecordAvailable && this.FieldColumnToogle.forEach((ele:any) => {
        if (ele.fieldName != "Name") {
          var Fields = {
            FieldID: ele.fieldID,
            FolderID: ele.folderID,
            IsDisplay: ele.isDisplay,
            ViewOrder: ele.viewOrder,
          };
          this.ToogleColumnFields.push(Fields);
        }
        
      });
    }
    if (modulename[0].mainModuleName == ModuleName.Contact) {
      this.isAnyRecordAvailable && this.FieldColumnToogle.forEach((ele:any) => {
        if (ele.fieldName != "Name") {
          var Fields = {
            FieldID: ele.fieldID,
            FolderID: ele.folderID,
            IsDisplay: ele.isDisplay,
            ViewOrder: ele.viewOrder,
          };
          this.ToogleColumnFields.push(Fields);
        }
      });
    }
    if (modulename[0].mainModuleName == ModuleName.Company) {
      this.isAnyRecordAvailable && this.FieldColumnToogle.forEach((ele:any) => {
        if (ele.fieldName != "Name") {
          var Fields = {
            FieldID: ele.fieldID,
            FolderID: ele.folderID,
            IsDisplay: ele.isDisplay,
            ViewOrder: ele.viewOrder,
          };
          this.ToogleColumnFields.push(Fields);
        }
      });
    }
  }

  onSubmitColumns() {
    this.colCount = 0;
    this.ToogleColumnFields;
    let NewToogleColumnFields = this.ToogleColumnFields.filter((v:any, i:any) => this.ToogleColumnFields.findIndex((item:any) => item.FieldID == v.FieldID) === i);
    this.selectedCustColumn.emit(NewToogleColumnFields);

    NewToogleColumnFields.forEach((element:any) => {
      this.colCount = element.isDisplay == true ? this.colCount + 1 : 0;
    });

  }

  changedToggle(item:any, event:any) {
    this.SubmitColumnsButton = true;
    this.folderListForID = JSON.parse(sessionStorage.getItem("menuModules")|| '[]');
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules")|| '[]');
    var modulename = menuModulesList.filter((x:any) => x.orgModuleName == this.modulename);
    if (modulename[0].mainModuleName == ModuleName.Core) {
      var data = this.folderListForID.filter((x:any) => x.mainModuleName === ModuleName.Core);
      this.folderId = data[0].folderID;
      this.ToogleColumnFields;
      this.ToogleColumnFields.forEach((s:any) => {
        if (s.FieldID === item.fieldID) {
          s.FieldID = item.fieldID;
          s.FolderID = this.folderId;//17;
          s.IsDisplay = event.checked;
          s.ViewOrder = item.viewOrder;
        }
      });
    }
    if (modulename[0].mainModuleName == ModuleName.Contact) {
      //var data= this.folderListForID.filter((x:any) => x.folderName === modulename[0].mainModuleName);
      // this.folderId=data[0].folderID;  
      var data = this.folderListForID.filter((x:any) => x.mainModuleName === ModuleName.Contact);
      this.folderId = data[0].folderID;
      this.ToogleColumnFields;
      this.ToogleColumnFields.forEach((s:any) => {
        if (s.FieldID === item.fieldID) {
          s.FieldID = item.fieldID;
          s.FolderID = this.folderId;//20;
          s.IsDisplay = event.checked;
          s.ViewOrder = item.viewOrder;
        }
      });
    }
    if (modulename[0].mainModuleName == ModuleName.Company) {
      // var data= this.folderListForID.filter((x:any) => x.folderName === modulename[0].mainModuleName);
      // this.folderId=data[0].folderID;
      var data = this.folderListForID.filter((x:any) => x.mainModuleName === ModuleName.Company);
      this.folderId = data[0].folderID;
      this.ToogleColumnFields;
      this.ToogleColumnFields.forEach((s:any) => {
        if (s.FieldID === item.fieldID) {
          s.FieldID = item.fieldID;
          s.FolderID = this.folderId;//19;
          s.IsDisplay = event.checked;
          s.ViewOrder = item.viewOrder;
        }
      });
    }
  }

  // isAllSelectedRow(event, element) {
  //     let obj = {
  //       selectedRecord: element.CoreID,
  //       isFavorite:element.IsFavorite
  //     };
  //     if (event.checked) {
  //       this.selectedRecordDeleteArray.push(obj);
  //     } else {
  //       let removeIndex = this.selectedRecordDeleteArray.findIndex(
  //         (itm) => itm.selectedRecord === element.CoreID);
  //       if (removeIndex !== -1) this.selectedRecordDeleteArray.splice(removeIndex, 1);
  //     }

  //     if (this.selectedRecordDeleteArray.length > 0) {
  //       this.SelectedRecordForDeleFav = true;
  //     }
  //     else {
  //       this.SelectedRecordForDeleFav = false;
  //       this.selectedRecordDeleteArray = [];
  //     }
  //     // if(this.selectedRecordDeleteArray.length==0){
  //     //   this.allRecord=true;
  //     //   this.particularRecord=false;
  //     //   return;
  //     // }  
  //     // if(this.totalCount==this.selectedRecordDeleteArray.length){
  //     //  this.allRecord=true;
  //     //  this.particularRecord=false;
  //     // }
  //     // if(this.totalCount!=this.selectedRecordDeleteArray.length){       
  //     //   this.allRecord=false;
  //     //   this.particularRecord=true;
  //     // }        
  // }

  // isAllSelected() {
  //   const numSelected = this.selection.selected.length;
  //   const numRows = this.dataSource.data.length;
  //   const page = this.pageSize;
  //   return numSelected === numRows;
  // }

  // masterToggle() {
  //     this.isAllSelected() ?
  //     this.selection.clear() :
  //     this.dataSource.data.forEach(row => this.selection.select(row));
  //     this.selectedRecordDeleteArray=[];    

  //     if (this.selection.selected.length > 0) {
  //       for (let i = 0; i < this.selection.selected.length; i++) {          
  //           let obj = {
  //             selectedRecord: this.selection.selected[i].CoreID,
  //             isFavorite:this.selection.selected[i].IsFavorite
  //           };
  //            this.selectedRecordDeleteArray.push(obj);    
  //       }
  //       this.SelectedRecordForDeleFav = true;
  //     }
  //     else {
  //       this.SelectedRecordForDeleFav = false;
  //       this.selectedRecordDeleteArray = [];
  //     }

  //     // if(this.selectedRecordDeleteArray.length==0){
  //     //   this.allRecord=true;
  //     //   this.particularRecord=false;
  //     //   return;
  //     // }      
  //     // if(this.totalCount==this.selectedRecordDeleteArray.length){
  //     //   this.allRecord=true;
  //     //   this.particularRecord=false;
  //     // }
  //     // if(this.totalCount!=this.selectedRecordDeleteArray.length){
  //     //    this.allRecord=false;
  //     //    this.particularRecord=true;
  //     // }
  // }



  getCheckboxParticular(event:any, element:any) {
    this.allRecord = false;
    var fullName;
    var tarea = element.Name;
     if (/(http(s?)):\/\//i.test(tarea)) {
      fullName = element.Name;
      fullName = fullName.split(',');
      fullName = fullName[0];
    }
    else{
      fullName = element.Name;
    }
    let obj = {
      selectedRecord: element.CoreID,
      isFavorite: element.IsFavorite,
      subFolderID: element.TypeID,
      name: fullName, //element.Name,
      email:element.Email,
    };
    if (event.checked) {
      this.selectedRecordDeleteArray.push(obj);
    } else {
      let removeIndex = this.selectedRecordDeleteArray.findIndex(
        (itm:any) => itm.selectedRecord === element.CoreID);
      if (removeIndex !== -1) this.selectedRecordDeleteArray.splice(removeIndex, 1);
    }

    if (this.selectedRecordDeleteArray.length > 0) {
      this.SelectedRecordForDeleFav = true;
    } else {
      this.SelectedRecordForDeleFav = false;
      this.selectedRecordDeleteArray = [];
    }

    if (this.dataSource.data.length > 0) {
      const myArrayFiltered = this.dataSource.data.filter((el) => {
        return this.selectedRecordDeleteArray.some((f:any) => {
          return f.selectedRecord === el.CoreID;
        });
      });
      if (myArrayFiltered.length == this.dataSource.data.length) {
        this.checkedAll = true;
      } else {
        this.checkedAll = false;
      }
    }

  }

  //   compare(a: number | string, b: number | string, isAsc: string) {
  //     if(isAsc == 'asc'){
  //       return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  //     }
  //     if(isAsc == 'desc'){
  //       return (a < b ? 1 : 1) * (isAsc ? 1 : 1);
  //     }
  // }

  private compare(a:any, b:any, isAsc:any) {
    //  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    if (isAsc == 'asc') {
      return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }
    if (isAsc == 'desc') {
      return (a < b ? 1 : 1) * (isAsc ? 1 : 1);
    }
  }


  announceSortChange(sortState: Sort) {
    this.dataSource.sort = this.sort;
    this.DataSource = this.dataSources;
    this.FieldColumnToogle;
    var datafieldID:any=[]=[];

    if(this.mainModuleName=="Core"){
     datafieldID= this.FieldColumnToogle.filter((x:any)=>x.fieldName==sortState.active);
     if(datafieldID.length>0){
     // if(datafieldID[0].fieldName!=="Name"){
       var isDesc:boolean=false;
       if(sortState.direction=="desc"){
        isDesc=false;
       }
      if(sortState.direction=="asc"){
        isDesc=true;
       }
      var obj={
        sortingField:datafieldID[0].fieldID,
        isDesc:isDesc
      }
       this.sorList.emit(obj);
       return;
       }
    //  }     
    }
  

   if(this.mainModuleName!="Core"){
    this.DataSource = this.dataSources.sort((a:any, b:any) => {
      return this.compare(a[sortState.active], b[sortState.active], sortState.direction);
    });
   }
  
    var list = [];
    var ccc = [];
    if (this.DataSource.length > 0) {
      ccc = this.CCCList.filter((x:any) => x.orgModuleName == this.modulename);
      if (ccc.length > 0) {
        if (ccc[0].mainModuleName == ModuleName.Core) {
          // list = JSON.parse(sessionStorage.getItem("coreList"));
          // for (var new_index = 0; new_index < this.DataSource.length; new_index++) {
          //   var old_index = list.findIndex(el => el.coreID === this.DataSource[new_index].CoreID);
          //   list.splice(new_index, 0, list.splice(old_index, 1)[0]);
          // }
          // sessionStorage.setItem('coreList', JSON.stringify(list));
        }
        if (ccc[0].mainModuleName == ModuleName.Contact) {
          list = JSON.parse(sessionStorage.getItem("contactList")|| '[]');
          for (var new_index = 0; new_index < this.DataSource.length; new_index++) {
            var old_index = list.findIndex((el:any) => el.contactID === this.DataSource[new_index].CoreID);
            list.splice(new_index, 0, list.splice(old_index, 1)[0]);
          }
          sessionStorage.setItem('contactList', JSON.stringify(list));
        }
        if (ccc[0].mainModuleName == ModuleName.Company) {
          list = JSON.parse(sessionStorage.getItem("companyList")|| '[]');
          for (var new_index = 0; new_index < this.DataSource.length; new_index++) {
            var old_index = list.findIndex((el:any) => el.companyID === this.DataSource[new_index].CoreID);
            list.splice(new_index, 0, list.splice(old_index, 1)[0]);
          }
          sessionStorage.setItem('companyList', JSON.stringify(list));
        }
      }
    }
  }

  //Checkbox for All 
  getCheckboxAll(event:any) {
    this.dataSource.sort = null;
    this.allRecord = false;
    if (event.checked == true) {
      this.checkedAll = true;
      this.dataSource.data.forEach(e => {
        e.IsChecked = true;
      });
      if (this.dataSource.data.length > 0) {
        this.dataSource.data.forEach(x => {
          var Check :any= [];
          Check = this.selectedRecordDeleteArray.filter((y:any) => y.selectedRecord === x.CoreID);
          if (Check.length > 0) {
            this.dataSource.data.find(y => y.CoreID == Check[0].selectedRecord).IsChecked = true;
          } else {
            var fullName;
            var tarea = x.Name;
            if (/(http(s?)):\/\//i.test(tarea)) {
              fullName = x.Name;
              fullName = fullName.split(',');
              fullName = fullName[0];
            }
          else{
             fullName = x.Name;
            }
            let obj = {
              selectedRecord: x.CoreID,
              isFavorite: x.IsFavorite,
              subFolderID: x.TypeID,
              name: fullName,//x.Name,
              email:x.Email,
            };
            this.selectedRecordDeleteArray.push(obj);
          }
        });
        this.SelectedRecordForDeleFav = true;
      } else {
        this.SelectedRecordForDeleFav = false;
        this.selectedRecordDeleteArray = [];
      }
    } else {
      this.checkedAll = false;
      this.dataSource.data.forEach(x => {
        x.IsChecked = false;
        var Check :any= [];
        Check = this.selectedRecordDeleteArray.filter((y:any) => y.selectedRecord === x.CoreID);
        if (Check.length > 0) {
          this.dataSource.data.find((y:any) => y.CoreID == Check[0].selectedRecord).IsChecked = false;
          let removeIndex = this.selectedRecordDeleteArray.findIndex(
            (itm:any) => itm.selectedRecord === x.CoreID);
          if (removeIndex !== -1) this.selectedRecordDeleteArray.splice(removeIndex, 1);
        }
      });

      if (this.selectedRecordDeleteArray.length > 0) {
        this.SelectedRecordForDeleFav = true;
      } else {
        this.SelectedRecordForDeleFav = false;
        this.selectedRecordDeleteArray = [];
      }
    }
  }


  DeleteRecord() {
    const message = `Are you sure you want to delete selected record?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);    
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          this.deleteList = [];
          this.SelectedIdList = [];
          this.SelectedIdList = this.selectedRecordDeleteArray;
          for (let i = 0; i < this.SelectedIdList.length; i++) {
            const selectedCoreID = this.SelectedIdList[i].selectedRecord;
            this.deleteList.push(selectedCoreID);
          }
          this.deleteList = this.deleteList.join(',');
          var selectedCoreIdArray = this.deleteList.split(',').map(Number);

          this.selectedRecordDelete.emit(selectedCoreIdArray);

          this.SelectedRecordForDeleFav = false;
          this.selectedRecordDeleteArray = [];
          this.checkedAll = false;
          // this.selection.selected.forEach(item => {
          //   let index: number = this.dataSource.data.findIndex(d => d === item);  
          //   this.dataSource.data.splice(index, 1)
          //   this.dataSource = new MatTableDataSource<Element>(this.dataSource.data);
          // });
          // this.selection = new SelectionModel<Element>(true, []);
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }


  ArchiveRecord() {
    const message = `Are you sure you want to archive selected record?`;
    const title = `Confirm Archive`;   
    const confirm = `Archive`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          this.deleteList = [];
          this.SelectedIdList = [];
          this.SelectedIdList = this.selectedRecordDeleteArray;
          for (let i = 0; i < this.SelectedIdList.length; i++) {
            const selectedCoreID = this.SelectedIdList[i].selectedRecord;
            this.deleteList.push(selectedCoreID);
          }
          this.deleteList = this.deleteList.join(',');
          var selectedCoreIdArray = this.deleteList.split(',').map(Number);

          this.selectedRecordArchive.emit(selectedCoreIdArray);

          this.SelectedRecordForDeleFav = false;
          this.selectedRecordDeleteArray = [];
          this.checkedAll = false;
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  ActivateRecord() {
    const message = `Are you sure you want to activate selected record?`;
    const title = `Confirm `;   
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);   
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          this.deleteList = [];
          this.SelectedIdList = [];
          this.SelectedIdList = this.selectedRecordDeleteArray;
          for (let i = 0; i < this.SelectedIdList.length; i++) {
            const selectedCoreID = this.SelectedIdList[i].selectedRecord;
            this.deleteList.push(selectedCoreID);
          }
          this.deleteList = this.deleteList.join(',');
          var selectedCoreIdArray = this.deleteList.split(',').map(Number);

          this.selectedRecordActivate.emit(selectedCoreIdArray);

          this.SelectedRecordForDeleFav = false;
          this.selectedRecordDeleteArray = [];
          this.checkedAll = false;
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  SendtoPaychex() {
    if (this.showPaycheck == false) {
      return;
    }
    this.SelectedIdList = [];
    this.SelectedIdList = this.selectedRecordDeleteArray;

    this.selectedRecordSendtoPaychex.emit(this.SelectedIdList);
    this.SelectedRecordForDeleFav = false;
    this.selectedRecordDeleteArray = [];
    this.checkedAll = false;
  }

  SendtoPendingPatientPCC() {
    if (this.showPCC == false) {
      return;
    }
    this.SelectedIdList = [];
    this.SelectedIdList = this.selectedRecordDeleteArray;

    this.selectedRecordSendtoPendingPatientPCC.emit(this.SelectedIdList);
    this.SelectedRecordForDeleFav = false;
    this.selectedRecordDeleteArray = [];
    this.checkedAll = false;
  }



  AddFavorite() {
    this.deleteList = [];
    this.SelectedIdList = [];
    this.SelectedIdList = this.selectedRecordDeleteArray;

    this.selectedForFalse = this.SelectedIdList.filter((x:any) => x.isFavorite == false);

    if (this.selectedForFalse.length > 0) {
      this.SelectedIdList = this.SelectedIdList.filter((x:any) => x.isFavorite !== true);
    }

    this.selectedForTrue = this.SelectedIdList.filter((x:any) => x.isFavorite == true);
    if (this.selectedForTrue.length > 0) {
      this.SelectedIdList = this.SelectedIdList.filter((x:any) => x.isFavorite !== false);
    }

    if (this.selectedForFalse.length > 0) {
      this.deleteList = [];
      for (let i = 0; i < this.SelectedIdList.length; i++) {
        const selectedCoreID = this.SelectedIdList[i].selectedRecord;
        this.deleteList.push(selectedCoreID);
      }
      this.deleteList = this.deleteList.join(',');
      var selectedCoreIdArray = this.deleteList.split(',').map(Number);
      this.selectedRecordForAddFavorite.emit(selectedCoreIdArray);
    }

    if (this.selectedForTrue.length > 0) {
      this.deleteList = [];
      for (let i = 0; i < this.SelectedIdList.length; i++) {
        const selectedCoreID = this.SelectedIdList[i].selectedRecord;
        this.deleteList.push(selectedCoreID);
      }
      this.deleteList = this.deleteList.join(',');
      var selectedCoreIdArray = this.deleteList.split(',').map(Number);

      this.selectedRecordForDeleteFavorite.emit(selectedCoreIdArray);
    }

    this.SelectedRecordForDeleFav = false;
    this.selectedRecordDeleteArray = [];
    this.checkedAll = false;
    // this.selection.selected.forEach(item => {
    //   let index: number = this.dataSource.data.findIndex(d => d === item);
    //   this.dataSource.data.splice(index, 1)
    //   this.dataSource = new MatTableDataSource<Element>(this.dataSource.data);
    // });
    // this.selection = new SelectionModel<Element>(true, []);
  }


  DeleteFavorite(element:any) {
    this.Filtername;
    this.deleteList = [];
    var id = element.CoreID;
    this.deleteList.push(id);

    this.selectedRecordForDeleteFavorite.emit(this.deleteList);

    this.SelectedRecordForDeleFav = false;
    this.selectedRecordDeleteArray = [];
    this.checkedAll = false;
    const resident = this.dataSource.data.find(r => r.CoreID === id);
    if (resident) {
      resident.favouriteColorCode = "";
      resident.IsFavorite = false;
     }
     
    // this.selection.selected.forEach(item => {
    //   let index: number = this.dataSource.data.findIndex(d => d === item);    
    //   this.dataSource.data.splice(index, 1)
    //   this.dataSource = new MatTableDataSource<Element>(this.dataSource.data);
    // });
    // this.selection = new SelectionModel<Element>(true, []);     
  }

  AddRowFavorite(element:any,templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
    this.deleteList = [];
    var id = element.CoreID;
    this.deleteList.push(id);
    this.currentFavoriteElement = element;
    return; 
  }

AddRowImportant(element: any, templateRef: TemplateRef<any>) {
//   // Optimistically toggle
//   element.IsImportant = true;
//  element.IsImportantColorCode ="";
//   // Open color picker dialog
  this.dialog.open(templateRef, {
    panelClass: 'custom-modalbox',
  });

  this.deleteList = [];
  this.deleteList.push(element.CoreID);

  this.currentImportantFavoriteElement = element;
}


  AddFavoriteForFilter(filter:any) {
    var filterId = filter.filterID;
    this.addFavoriteForFilter.emit(filterId);
  }

  DeleteFavoriteForFilter(filter:any) {
    var filterId = filter.filterID;
    this.deleteFavoriteForFilter.emit(filterId);
  }

  RemoveFilter(filter:any) {
    const message = `Are you sure you want to delete this filter?`;
    const title = `Confirm Delete`;   
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);   
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var filterId = filter.filterID;
          this.removeSelectedFilter.emit(filterId);
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }


  broadcastMessage(templateRef: TemplateRef<any>) {
    var broadCastList :any= [];
    this.selectedRecordDeleteArray.forEach((selectedRecord:any) => {
      broadCastList.push(selectedRecord.selectedRecord);
    });
    this.startBroadCasting.emit(broadCastList);
    this.SelectedRecordForDeleFav = false;
    this.selectedRecordDeleteArray = [];
  }


  //  ================== Export ======================================//

  Feildproperty: any = [] = [];
  FolderId: number = 0;
  particularRecord: boolean = false;
  allRecord: boolean = true;
  SelectedRecords: string = "";
  AllRecords: string = "";
  toggleAll: boolean = true;
  TypeIdForExport: number = 0;
  spinner: boolean = false;
  ExportRecordButton: boolean = false;

  // Get Field For Export for Dropdown // 
  getFieldForImportExport() {
    var ReqModel = {
      folderID: this.FolderId,
      UserId: this.currentUser.UID,
      OrganizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
    }
    this.settingsService.GetFieldForImportExport(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.Feildproperty = this.responseHolder.data;
          if (this.Feildproperty.length > 0) {
            this.Feildproperty.forEach((e:any) => {
              e.IsExport = true;
            });
          }
        } else {
          this.Feildproperty = [];
        }
      } else {
        this.Feildproperty = [];
      }
    });
  }

  // Open pop up for Export Data
  ExportData(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
    this.spinner = false;
    this.ExportRecordButton = false;
    this.toggleAll = true;
    if (this.selectedRecordDeleteArray.length > 0) {
      this.allRecord = false;
      this.SelectedRecords = "SelectedRecords";
      this.AllRecords = "";
    } else {
      this.allRecord = true;
      this.AllRecords = "AllRecords";
      this.SelectedRecords = "";
    }
    // if(this.allRecord==false){
    //   this.SelectedRecords="SelectedRecords";
    //   this.AllRecords="";
    // }
    // if(this.allRecord==true){
    //   this.AllRecords="AllRecords";
    //   this.SelectedRecords="";
    // }
    this.getFieldForImportExport();
  }

  selectOptionForExport(event: any) {
    if (event.checked == true) {
      this.AllRecords = "AllRecords";
      this.SelectedRecords = "";
    } else {
      this.SelectedRecords = "SelectedRecords";
      this.AllRecords = "";
    }
  }

  //Toggle for Particular 
  getToggleParticular(event:any, item:any) {
    if (this.Feildproperty.length > 0) {
      if (event.checked == true) {
        this.Feildproperty.forEach((e:any) => {
          if (e.fieldID == item.fieldID) {
            e.IsExport = true;
          }
        });
      } else {
        this.Feildproperty.forEach((e:any) => {
          if (e.fieldID == item.fieldID) {
            e.IsExport = false;
          }
        });
      }
    }
    var CheckRecords = [];
    CheckRecords = this.Feildproperty.filter((x:any) => x.IsExport == false);
    if (CheckRecords.length > 0) {
      this.toggleAll = false;
    } else {
      this.toggleAll = true;
    }
  }

  //Toggle for All 
  getToggleAll(event:any) {
    if (event.checked == true) {
      this.toggleAll = true;
      this.Feildproperty.forEach((e:any) => {
        e.IsExport = true;
      });
    } else {
      this.toggleAll = false;
      this.Feildproperty.forEach((e:any) => {
        if (e.fieldName == "Name") {
          e.IsExport = true;
        } else {
          e.IsExport = false;
        }
      });
    }
  }

  ExportRecord() {
    this.spinner = true;
    this.ExportRecordButton = true;
    var ColumnHeadersExport :any= [];
    var GetAllTransactionIds :any= [];
    if (this.Feildproperty.length > 0) {
      var CheckIsExport = [];
      CheckIsExport = this.Feildproperty.filter((x:any) => x.IsExport == true);
      CheckIsExport.forEach((e:any) => {
        ColumnHeadersExport.push(e.fieldID);
      });
    }

    if (this.AllRecords == "AllRecords") {
      GetAllTransactionIds = this.allids;
    }
    if (this.SelectedRecords == "SelectedRecords") {
      if (this.selectedRecordDeleteArray.length > 0) {
        this.selectedRecordDeleteArray.forEach((e:any) => {
          GetAllTransactionIds.push(e.selectedRecord);
        });
      }
    }

    var ReqModel = {
      type: this.TypeIdForExport,
      ids: GetAllTransactionIds.join(),
      fieldIds: ColumnHeadersExport.join(),
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    }
    //return
    this.settingsService.ExportCSV(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.spinner = false;
        this.ExportRecordButton = false;
        this.SelectedRecordForDeleFav = false;
        this.selectedRecordDeleteArray = [];
        this.checkedAll = false;
        this.responseHolder = response;
        if (this.responseHolder.isSuccess == true) {
          this.close();
          var base64URL = this.responseHolder.exportFile;
          if (base64URL != null && base64URL != "") {
            const data = 'data:text/csv;base64,' + base64URL;
            var Csvname = "";
            if (this.TypeIdForExport == 1) { //For Core
              Csvname = this.modulename + 'CSV' + this.responseHolder.total;
            }
            if (this.TypeIdForExport == 2) { //For Contact
              Csvname = this.modulename + 'CSV' + this.responseHolder.total;
            }
            if (this.TypeIdForExport == 3) { //For Company
              Csvname = this.modulename + 'CSV' + this.responseHolder.total;
            }
            FileSaver.saveAs(data, Csvname);
            this.toastr.success(+this.responseHolder.total + ' Record have been exported successfully.', '', {
              timeOut: 3000,
            });
            this.dataSource.sort = null;
            //this.dataSource.sort.sortables=null;
            this.CheckBoxClearExport.emit();
            // this.cdr.detectChanges();
          }
        } else {
          this.spinner = false;
          this.ExportRecordButton = false;
          this.toastr.error(this.responseHolder.exception, '', {
            timeOut: 3000,
          });
        }
      } else {
        this.spinner = false;
        this.ExportRecordButton = false;
      }
    });
  }

  AttachToTaskList() {
    const dialogRef = this.dialog.open(AttachToTaskListComponent, {     
      data: {       
        moduleName: this.mainModuleName,
        selectedRecord: this.selectedRecordDeleteArray,
        panelClass:  ['no-padding', 'no-scrolls'],        
      }
    });
    dialogRef.afterClosed().subscribe(result => {     
      if(result!=null && result!=undefined){
      }
      if(result=="Added"){
        this.SendtoAttachToTaskList.emit(true);
        this.recordAddedForTaskList();
      }
    });   
  }

  recordAddedForTaskList(){
    this.SelectedRecordForDeleFav = false;
    this.selectedRecordDeleteArray = [];
    this.checkedAll = false;
  }
 

  ImportForm3CTaskList() {
    const dialogRef = this.dialog.open(ImportForm3CListComponent, {     
      data: {
        moduleName: this.mainModuleName,
        selectedRecord: this.selectedRecordDeleteArray,
        panelClass: 'task_template',
      }
    });
    dialogRef.afterClosed().subscribe(result => {     
      if(result!=null && result!=undefined){
      }
      if(result=="Added"){
        this.SendtoAttachToTaskList.emit(true);
        this.recordAddedForTaskList();
      }
    });   
  }

  MoveToOtherOffice() {   
    const dialogRef = this.dialog.open(AddOfficeComponent, {     
      data: {
        moduleName: this.mainModuleName,
        selectedRecord: this.selectedRecordDeleteArray,
        //panelClass: 'task_template',
      }
    });
    dialogRef.afterClosed().subscribe(result => {     
      if(result!=null && result!=undefined){
      }
      if(result=="Added"){
        this.SendtoAttachToTaskList.emit(true);
        this.recordAddedForTaskList();
      }
    });   
  }

  filesArray: any[] = [
    {
      filePath:
        'https://questil.com/DocVault/EIMAS/ArchivementDoc/20220608123450I2015R_SPLR_Inside_EiMAS_with_DOE_AQ_06_22_0001_20220608.pdf',
    },
    {
      filePath:
        'https://questil.com/DocVault/Eimas/Document/Assignment_Material/2022/20220616105535NWB3IX_Test_Case_Akkha_Vardhana.xlsx',
    },
    {
      filePath: 'https://i.imgur.com/R4gpt2H_d.webp',
    },
    {
      filePath: 'https://i.imgur.com/BevyDwM_d.webp',
    },
    {
      filePath: 'https://i.imgur.com/pHMY26k_d.webp',
    },
    {
      filePath:
        'https://images-americanas.b2w.io/produtos/4158226624/imagens/cactos-pelucia-dancante-e-falante-toca-musica-repete-fala-brinquedo-cactus-infantil-canta-danca-fala-imita-gira-luz-pronta-entrega/4158226641_1_xlarge.jpg',
    },
  ];

  formDialog: FormGroup;
  selectedFileArray:any=[]=[];
  getFilesList:any=[]=[];

  openDownloadPanel(templateRef: TemplateRef<any>) {   
    let group = {};
    this.formDialog = new FormGroup(group);
    this.formDialog.addControl('placeholderName',this.formBuilder.control(''));  
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }

  async downloadFile(data:any) {   
    var GetAllTransactionIds :any= [];
    if (this.selectedRecordDeleteArray.length > 0) {
      this.selectedRecordDeleteArray.forEach((e:any) => {
        GetAllTransactionIds.push(e.selectedRecord);
      });
    }
    var ReqModel={
      ciDs: GetAllTransactionIds,//[0],
      cType: this.TypeIdForExport,
      placeholderName: data.placeholderName,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    }
    this.loaderService.show();
    this.spinner=true;
    this.formDialog.markAsPristine();
    this.settingsService.downloadFilesInZip(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        //this.loaderService.hide();
        if(this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data.length>0) {
          // this.downloadService.createZip(this.responseHolder.data,data.placeholderName);  
          this.selectedFileArray = [];     
          this.getFilesList=[];     
          this.responseHolder.data.forEach((s:any) => {
            this.selectedFileArray.push(s);
          });

          for (let i = 0; i < this.selectedFileArray.length; i++) {
            const selectedFileName = this.selectedFileArray[i].split('/').pop();
            this.settingsService.getAttachment(this.selectedFileArray[i],selectedFileName).subscribe((response) => {
            if (response !== undefined) {
                 // const data = 'data:' + response.data.contentType + ';base64,' + response.data.base64URL;
                 // FileSaver.saveAs(data, selectedFileName);
                 var obj={
                  fileName: selectedFileName,
                  base64: response.data.base64URL, // Replace with actual Base64 string
                  mimeType:this.getContentType(this.selectedFileArray[i]),// 'application/pdf'//response.data.contentType
                 }
                 this.getFilesList.push(obj);
                 
                  // After the last file is fetched, trigger the ZIP download
                 if (this.getFilesList.length === this.selectedFileArray.length) {
                   this.downloadMultipleBase64AsZip(this.getFilesList, data.placeholderName);
                  //  this.toastr.success('Zip Downloaded successfully', '', {
                  //   timeOut: 3000,
                  //  });
                   this.spinner=false;
                   this.loaderService.hide();
                   this.close(); 
                 }
                }else{                 
                }
              });
             
           } 
          
                  
        } else {
          this.spinner=false;
          this.toastr.warning('No Record Found', '', {
           timeOut: 3000,
          });      
          this.close();    
          this.loaderService.hide();
        }
      } else {
        this.spinner=false;
        this.toastr.warning('No Record Found', '', {
          timeOut: 3000,
         }); 
        this.close();
        this.loaderService.hide();  
      }
       //this.downloadMultipleBase64AsZip(this.getFilesList,data.placeholderName);
    });  
  }


  base64ToBlob(base64: string, mime: string) {
    let base64Data = base64;
  
    // Check and remove any potential data URI scheme (e.g., "data:image/png;base64,")
    if (base64.includes(',')) {
      base64Data = base64.split(',')[1];
    }
  
    // Sanitize the Base64 string by removing any non-Base64 characters
    base64Data = base64Data.replace(/[^A-Za-z0-9+/=]/g, '');
  
    try {
      const byteString = atob(base64Data);
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const uint8Array = new Uint8Array(arrayBuffer);
  
      // Convert the Base64 decoded string into bytes
      for (let i = 0; i < byteString.length; i++) {
        uint8Array[i] = byteString.charCodeAt(i);
      }
  
      // Return the Blob with the provided MIME type
      return new Blob([arrayBuffer], { type: mime });
    } catch (error) {
      //console.error('Failed to decode Base64 string', error);
      return null;
    }
  }
  
  // base64ToBlob(base64: string, mime: string) {
  //   const byteString = atob(base64.split(',')[1]);
  //   const ab = new ArrayBuffer(byteString.length);
  //   const ia = new Uint8Array(ab);
  //   for (let i = 0; i < byteString.length; i++) {
  //     ia[i] = byteString.charCodeAt(i);
  //   }
  //   return new Blob([ab], { type: mime });
  // }

  downloadMultipleBase64AsZip(base64Files: { fileName: string, base64: string, mimeType: string }[],zipname:any) {
    const zip = new JSZip();
    //const folder = zip.folder('files')!;

    // Loop through the base64 data and convert it to files, adding them directly to the root of the ZIP
    base64Files.forEach(file => {
     const blob = this.base64ToBlob(file.base64, file.mimeType);
     zip.file(file.fileName, blob);
    });

     // Generate the zip and trigger the download
     zip.generateAsync({ type: 'blob' }).then((content:any) => {
      saveAs(content, zipname + '.zip');
      this.toastr.success('Zip file Downloaded successfully', '', {
        timeOut: 3000,
       });
     });
  }

  getContentType(url: string): string {
    var extension = /(?:\.([^.]+))?$/.exec(url)?.[1] || '';
    var contentType = '';

    switch (extension) {
      case 'pdf': {
        return 'application/pdf';
      }
      case 'xlsx': {
        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      }
      case 'xsl': {
        return 'application/vnd.ms-excel';
      }
      case 'csv': {
        return 'application/vnd.ms-excel';
      }
      case 'jpg':{
        return 'image/jpg';
      }
      case 'jpge':{
        return 'image/jpge';
      }
      default: {
        return 'application/json-patch+json';
      }
    }
  }
  

   colorShow:boolean=false;

   selectedColor(colors:any){   
     this.closeColor();
    if (this.currentFavoriteElement) {
     this.currentFavoriteElement.IsFavorite = true;
     this.currentFavoriteElement.favouriteColorCode = colors;
    }
    var obj={
      deleteList: this.deleteList,
      colors:colors
    }
    this.selectedRecordForAddFavorite.emit(obj);

    this.SelectedRecordForDeleFav = false;
    this.selectedRecordDeleteArray = [];
    this.checkedAll = false;
    const id = Object.values(this.deleteList)[0];
    const resident = this.dataSource.data.find(r => r.CoreID === id);
    if (resident) {
      resident.favouriteColorCode = colors;
      resident.IsFavorite = true;
     }
    this.closeColor();  
   }

selectedColorImp(color: string) {
  this.closeColor();

  // Immediately reflect selected color on UI
  this.currentImportantFavoriteElement.IsImportantColorCode = color;
  this.currentImportantFavoriteElement.IsImportant = true;

  this.toastr.success('Marked as important successfully.', '', { timeOut: 3000 });

  const requestModel = {
    coreId: this.currentImportantFavoriteElement.CoreID,
    isImportant: true,
    favouriteColorCode: color,
  };

  // Emit to parent (or call API here)
  this.selectedRecordForAddImportant.emit(requestModel);

  // Reset states if needed
  this.SelectedRecordForDeleFav = false;
  this.selectedRecordDeleteArray = [];
  this.checkedAll = false;
}


   closeColor(){
    this.dialog.closeAll();
   }

    thirdPartyApplicationList: any = [] = [];

  getThirdPartyApplicationList() {
    this.loaderService.show();
    var ReqModel = {
      isOffice: true,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
    }
    this.settingsService.getThirdPartyApis(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.thirdPartyApplicationList = this.responseHolder.data;
          if (this.thirdPartyApplicationList.length > 0) {
            var Paycheck = [];
            var PointClickCare = [];

            Paycheck = this.thirdPartyApplicationList.filter((x:any) => x.thirdPartyApiName.toLowerCase() == "Paychex".toLowerCase());
            PointClickCare = this.thirdPartyApplicationList.filter((x:any) => x.thirdPartyApiName.toLowerCase() == "PointClickCare".toLowerCase());

            if (Paycheck.length > 0) {
              if (Paycheck[0].apiAuthDetail != null) {
                if (Paycheck[0].apiAuthDetail.isRequestclientAccessed == true) {
                  sessionStorage.setItem('Paycheck', 'true');
                }
              }
            }
            if (PointClickCare.length > 0) {
              if (PointClickCare[0].apiAuthDetail != null) {
                if (PointClickCare[0].apiAuthDetail.isRequestclientAccessed == true) {
                  sessionStorage.setItem('PointClickCare', 'true');
                }
              }
            }
          }
        }
        else {
          this.thirdPartyApplicationList = [];
        }
      }
      else {
        this.thirdPartyApplicationList = [];
      }
    });
  }


   openFolderList() {
      const dialogRef = this.dialog.open(FolderForReferralComponent, {
        data: {
          from:'Core'
          //fileManagerItemID: this.fileManagerItemID,
        },
        width: '90vw',
        //height: '0vh',
        maxWidth: '100vw',
        maxHeight: '100vh',
        panelClass: 'signatureModal'
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result != undefined) {
         
        }
      });
    }

  // downloadFile(data:any) {

  //   const encryptedtoken = sessionStorage.getItem('userToken');
  //   const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
  //   const headers = new HttpHeaders({
  //     'Authorization': 'Bearer ' + token,
  //   });
    
  //   this.http.get("https://storage.flowtrics.com/ecmfilemanager/jenyorg%5C2503b67f-bd65-4649-ab35-91348d4c4100%5CMy%20Projects%5CCare_Plan1Blank_Doc_3-merged.pdf", { headers: headers, responseType: 'blob' }).subscribe(
  //     (blob) => {
  //       zip.file('test12', blob);
  //       zip.generateAsync({ type: 'blob' }).then((content) => {
  //         saveAs(content, zipFilename);
  //       });
  //     },
  //     (error) => {
  //       console.error('Error downloading file', error);
  //     }
  //   );
    
  //   // List of files to be downloaded (replace with your URLs or file sources)
  //   const files = [
  //     { name: '1.pdf', url: 'https://storage.flowtrics.com/ecmfilemanager/jenyorg%5C2503b67f-bd65-4649-ab35-91348d4c4100%5CMy%20Projects%5CCare_Plan1Blank_Doc_3-merged.pdf' },
  //     { name: '2.pdf', url: 'https://storage.flowtrics.com/ecmfilemanager/jenyorg%5C2503b67f-bd65-4649-ab35-91348d4c4100%5CMy%20Projects%5CCare_Plan1_8Blank_Doc_3-merged.pdf' },
  //     { name: '3.pdf', url: 'https://storage.flowtrics.com/ecmfilemanager/jenyorg%5C2503b67f-bd65-4649-ab35-91348d4c4100%5CMy%20Projects%5CCare_Plan1_10Blank_Doc_3-merged.pdf' },
  //   ];

  //   const zip = new JSZip();
  //   const zipFilename = data.placeholderName+ '.zip';;
    
  //   const filePromises = files.map(file => {
  //     return this.http.get(file.url, { responseType: 'blob' }).toPromise().then(blob => {
  //       zip.file(file.name, blob);
  //     });
  //   });

  //   // Once all files are added to the ZIP
  //   Promise.all(filePromises).then(() => {
  //     zip.generateAsync({ type: 'blob' }).then(content => {
  //       saveAs(content, zipFilename);
  //     });
  //   });
  // }
}
  











